var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnswered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    fill: "#F0FDF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "#15B79E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9716 15.7727V24.5H19.9148V16.8807H19.8636L17.733 18.2955V17.2216L19.9148 15.7727H20.9716Z",
    fill: "#0E9384"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswered);
export default __webpack_public_path__ + "static/media/answered.31da3ad718107ab041da2673a8e19b4d.svg";
export { ForwardRef as ReactComponent };